import { Inject, Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Methods } from "../shared/methods";
import { Contacto } from "./contact";
import { ContactsService } from "../services/contacts.service";
import swal from "sweetalert2";
import { Cell, DinamicData } from "../models/dinamic-data";
import { ConfigService } from "../services/config.service";

declare const $: any;

@Component({
  selector: "app-contacts",
  templateUrl: "./contacts.component.html",
  styleUrls: ["./contacts.component.css"],
})
export class ContactsComponent implements OnInit {
  public mtds: Methods = new Methods();
  public index = true;
  public loading = false;
  public saving = false;

  public contacts: Array<any> = [];
  public contactsList: Array<any> = [];
  public contact: Contacto = new Contacto();
  public contactsData: DinamicData = new DinamicData([
    "ID",
    "Name",
    "Email",
    "Work Phone",
    "Mobile Phone",
    "Actions",
  ]);
  public config;
  public filtrosContact = [];
  public pageContact = 1;
  public totalItemsContact = 0;
  public totalPaginasContact = 1;
  public paginaActualContact = 1;
  public itemsPorPaginaContact = "10";
  public configContact: Array<any> = [];
  constructor(
    private _router: Router,
    public dialogRef: MatDialogRef<ContactsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _contactService: ContactsService,
    private _config: ConfigService
  ) {
    console.log(data);
    // this.getContacts();
  }

  ngOnInit() {
    this._config.getConfig("locatiosnList").subscribe(
      (r) => {
        if (r.data) {
          this.configContact = JSON.parse(r.data.data);
        } else {
          this.configContact = this.mtds.colopt(this.contactsData.headers, [
            false,
          ]);
        }
        this.getListContacts();
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.loading = false;
      }
    );
  }
  updateConfigContact(e) {
    this.configContact = e;
    this._config.setConfig("contactList", this.configContact).subscribe((r) => {
      console.log(r);
    });
  }

  public loadingContacts = false;
  getListContacts() {
    // "ID",
    //   "Name",
    //   "Email",
    //   "Work Phone",
    //   "Mobile Phone",
    this.filtrosContact = [
      {
        key: "id",
        title: "id",
        value: "",
        type: "contains",
        key_type: "id_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "name",
        title: "Name",
        value: "",
        type: "contains",
        key_type: "name_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "email",
        title: "Email",
        value: "",
        type: "contains",
        key_type: "email_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "workphone",
        title: "Work Phone",
        value: "",
        type: "contains",
        key_type: "workphone_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "mobilephone",
        title: "Mobile Phone",
        value: "",
        type: "contains",
        key_type: "mobilephone_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      null,
    ];
    this.loadingContacts = true;
    this._contactService
      .showAll(this.data.id, this.data.type === "company")
      .subscribe(
        (r) => {
          console.log(r);
          if (r.code === 400 && r.msg === "Authorization not valid") {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          } else if (r.status === "success") {
            this.loadingContacts = false;
            console.log(r.data, "data aqiii");
            this.contactsList = r.data;
            this.contactsData.rows = [];
            this.paginaActualContact = Number(r.page_actual);
            this.itemsPorPaginaContact = String(r.items_per_page);
            this.totalItemsContact = Number(r.total_items_count);
            this.totalPaginasContact = Number(r.total_pages);
            for (let element of this.contactsList) {
              let actionButtons = [];

              actionButtons = [
                {
                  icon: "edit",
                  action: "Edit",
                  value: element,
                  color: "warning",
                },
                {
                  icon: "delete_outline",
                  action: "Remove",
                  value: element,
                  color: "danger",
                },
              ];

              this.contactsData.rows.push([
                new Cell(element.id),
                new Cell(element.name),
                new Cell(element.email),
                new Cell(element.phone),
                new Cell(element.mobilePhone),
                new Cell(actionButtons, { type: "actions" }),
              ]);
            }
            // this.mtds.initTable("#contactTable");
          } else {
            this.mtds.notifyError(r.msg, r.code);
          }
          this.loadingContacts = false;
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.loading = false;
        }
      );
  }
  getData(e) {
    this.loading = true;
    this._contactService
      .showAll(this.data.id, this.data.type === "company")
      .subscribe(
        (r) => {
          console.log(r);
          if (r.code === 400 && r.msg === "Authorization not valid") {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          } else if (r.status === "success") {
            this.contactsList = r.data;
            this.contactsData.rows = [];
            this.paginaActualContact = Number(r.page_actual);
            this.itemsPorPaginaContact = String(r.items_per_page);
            this.totalItemsContact = Number(r.total_items_count);
            this.totalPaginasContact = Number(r.total_pages);
            // this.mtds.initTable("#contactTable");
          } else {
            this.mtds.notifyError(r.msg, r.code);
          }
          this.loading = false;
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.loading = false;
        }
      );
  }

  new() {
    this.index = false;
    if (this.data.type === "company") {
      this.contact.isQuarter = this.data.id;
    } else {
      this.contact.locationId = this.data.id;
    }
    $("#nombre").focus();
  }

  punteroNombre() {
    $("#nombre").focus();
  }

  punteroCorreo() {
    $("#correo").focus();
  }

  punteroTel() {
    $("#tel").focus();
  }

  punteroMobil() {
    $("#mobil").focus();
  }

  show(contact) {
    console.log(contact, "aqui");
    this.contact.id = contact.id;
    this.contact.name = contact.name;
    this.contact.email = contact.email;
    this.contact.phone = contact.phone;
    this.contact.mobilePhone = contact.mobilePhone;
    if (this.data.type === "company") {
      this.contact.isQuarter = this.data.id;
    } else {
      this.contact.locationId = this.data.id;
    }
    this.index = false;
  }

  save() {
    this.saving = true;
    this._contactService.save(this.contact).subscribe(
      (r) => {
        console.log(r);
        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {
          this.mtds.notifySuccess("Contact has been saved successfully");
          this.close();
          this.getListContacts();
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.saving = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.saving = false;
      }
    );
  }

  actionContact(e) {
    console.log(e, "eeeeee");
    switch (e.action) {
      case "Edit": {
        console.log("se hace");
        this.show(e.id);
        break;
      }
      case "Remove": {
        this.delete(e.id.id);
        break;
      }
      default:
        break;
    }
  }
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: type,
      title: title,
    });
  }

  delete(id) {
    console.log("delete", id);
    swal
      .fire({
        title: "",
        text: "Are you sure to delete this contact?",
        showCancelButton: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "gts-btn-primary",
          cancelButton: "gts-btn-primary-outline",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then(
        function (result) {
          if (result.value) {
            console.log("id", id.id);
            this._contactService.delete(id).subscribe(
              (response) => {
                console.log(response);
                if (response.status === "success") {
                  this.showToast(
                    "success",
                    "Contact has been removed successfully",
                    2000
                  );
                  this.getListContacts();
                } else {
                  // this.mtds.notifyError(response.msg, response.code);
                }
              },
              (error) => {
                // this.mtds.notifyError(error.statusText, error.status);
              }
            );
          }
        }.bind(this)
      );
  }

  close() {
    this.index = true;
    this.contact = new Contacto();
  }
}
